jQuery(document).ready(function() {
  let product_widgets = jQuery(".product_widget");

  product_widgets.each(function() {
    const $widget = jQuery(this);

    // New way first, fallback to old way
    const widget_id = $widget.data("product-handle") || $widget.attr("id");
    const analytic_counts = $widget.data("analytes-count") || $widget[0].dataset.analytesCount || 0;

    if (!widget_id) return;

    $.getJSON("/products/" + widget_id + ".json", function(data) {
      $widget.html(
        '<div class="article-page-product-wrp white-bg">' +
          '<div class="article-page-product-img">' +
            '<a href="/products/' + data.product.handle + '">' +
              '<img width="150px" src="' + data.product.image.src + '" alt="product thumbnail">' +
            '</a>' +
          '</div>' +

          '<a style="text-decoration:none;" href="/products/' + data.product.handle + '">' +
            '<div class="article-page-product-text">' +
              '<h6 class="h8 teal-clr" style="text-transform:uppercase;">Specialized</h6>' +
              '<h6>' + data.product.title + '</h6>' +
              '<div class="product-analytes-count mt-1" style="padding-top:8px;">' +
                '<h6 class="analytes-count">' +
                  '<span data-analytes="' + analytic_counts + '">' + analytic_counts + '</span> Analytes Tested' +
                '</h6>' +
              '</div>' +
            '</div>' +
          '</a>' +

          '<div class="article-page-product-btn">' +
            '<a style="text-decoration:none;" href="/products/' + data.product.handle + '">' +
              '<h6>$ ' + data.product.variants[0].price + '</h6>' +
            '</a>' +

            '<product-form class="product-form">' +
              '<div class="product-form__error-message-wrapper" role="alert" hidden>' +
                '<span class="product-form__error-message"></span>' +
              '</div>' +

              '<form method="post" action="/cart/add" class="form" enctype="multipart/form-data" novalidate>' +
                '<input type="hidden" name="form_type" value="product">' +
                '<input type="hidden" name="utf8" value="✓">' +
                '<input type="hidden" name="id" value="' + data.product.variants[0].id + '">' +

                '<div class="product-form__buttons">' +
                  '<button type="button" class="add-to-cart-product-card underline-btn orange-clr orange-border" data-variant-id="' + data.product.variants[0].id + '">' +
                    '<span>Add to cart</span>' +
                    '<div class="loading-overlay__spinner hidden">' +
                      '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66">' +
                        '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
                      '</svg>' +
                    '</div>' +
                  '</button>' +
                '</div>' +
              '</form>' +
            '</product-form>' +
          '</div>' +
        '</div>'
      );
    });
  });
  
});